import { useRef, useState } from "react"
import { useLista, useManagedContext } from "../../components/hooks"
import { ServerRequest } from "../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../config/apis"
import { SectionHeading, TableCustom, WrapperAdvancedSearch } from "../../components/common"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToIdentificador, getNumeroRecibo_IdentificadorToObject } from "../../utils/convert"
import CuentaPagoDetalleModal from "../../components/controls/CuentaPagoDetalleModal"


const BusquedaVepsView = () => {
    const { setIsLoading } = useManagedContext()

    const searchRef = useRef()

    const [veps, setVeps] = useState([])
    const [tableVisible, setTableVisible] = useState(false)
    const [selectedVep, setSelectedVep] = useState(null)

    const [, getRowLista] = useLista({
        listas: ['TipoTributo'],
        memo: {
          key: 'TipoTributo',
          timeout: 0
        }
    });

    const getDescTipoTributo = (idTipoTributo) => {
        const row = getRowLista('TipoTributo', idTipoTributo);
        return row ? row.nombre : "";
    }

    const SearchVeps = () => {
        const { numeroVep, codigoBarrasCliente, numeroCuenta, fechaDesde, fechaHasta } = searchRef.current.filters

        setIsLoading(true)

        const params = new URLSearchParams()

        if (numeroVep) {
            const normalized = numeroVep.replace(/-/g, '')
            if (normalized.length < 4 || !/^\d+$/.test(normalized)) {
                setVeps([])
                setTableVisible(false)
                setIsLoading(false)
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'El formato del N° VEP es incorrecto')
                return
            }
            const objectNumeroVep = getNumeroRecibo_IdentificadorToObject(numeroVep)
            if (objectNumeroVep === "ERROR") {
                setVeps([])
                setTableVisible(false)
                setIsLoading(false)
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'El formato del N° VEP es incorrecto')
                return
            }
            params.append('codigoDelegacion', objectNumeroVep.codigoDelegacion)
            params.append('numeroRecibo', objectNumeroVep.numeroRecibo)
        }
        if (codigoBarrasCliente) params.append('codigoBarrasCliente', codigoBarrasCliente)
        if (numeroCuenta) params.append('numeroCuenta', numeroCuenta)
        if (fechaDesde) params.append('fechaRegistroDesde', fechaDesde.toISOString())
        if (fechaHasta) params.append('fechaRegistroHasta', fechaHasta.toISOString())

        const paramsUrl = `/filter?${params.toString()}`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.CUENTA_PAGO,
            paramsUrl,
            null,
            res => res.json().then(data => {
                setVeps(data)
                setTableVisible(true)
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onView: (item) => {
            setSelectedVep(item)
        }
    }

    return <>
        <SectionHeading titles={[{ title: 'VEPs' }, { title: 'Búsqueda de VEPs' }]} />

        <section className='section-accordion'>
            <WrapperAdvancedSearch
                ref={searchRef}
                requireFilter={true}
                filters={[
                    { title: 'N° VEP', field: 'numeroVep', type: 'string', size: 2, searchOnEnter: true },
                    { title: 'Código de barras', field: 'codigoBarrasCliente', type: 'string', size: 4, searchOnEnter: true },
                    { title: 'N° cuenta', field: 'numeroCuenta', type: 'string', size: 2, searchOnEnter: true },
                    { title: 'Fecha desde', field: 'fechaDesde', type: 'date', size: 2 },
                    { title: 'Fecha hasta', field: 'fechaHasta', type: 'date', size: 2, minValueField: 'fechaDesde' },
                ]}
                onSearch={SearchVeps}
                onClear={() => {
                    setVeps([])
                    setTableVisible(false)
                }}
            />

            {tableVisible && (
                <TableCustom
                    className={'TableCustomBase m-top-20'}
                    data={veps}
                    avmr={avmr}
                    messageEmpty="No se encontraron resultados"
                    columns={[
                        { Header: 'N° cuenta', accessor: 'numeroCuenta', width: '14%' },
                        { Header: 'Tipo de tributo', Cell: (props) => getDescTipoTributo(props.value), accessor: 'idTipoTributo', width: '10%' },
                        { Header: 'N° VEP', accessor: 'numeroRecibo', width: '12%', Cell: ({ row }) => (row.original.numeroRecibo > 0) ? getNumeroRecibo_ObjectToIdentificador(row.original) : row.original.codigoBarras },
                        { Header: 'Período', accessor: 'periodo', width: '8%', alignCell: 'right' },
                        { Header: 'Cuota', accessor: 'cuota', width: '6%', alignCell: 'right' },
                        { Header: 'Importe 1', accessor: 'importeVencimiento1', Cell: (data) => getFormatNumber(data.value, 2), width: '10%', alignCell: 'right' },
                        { Header: 'Importe 2', accessor: 'importeVencimiento2', Cell: (data) => getFormatNumber(data.value, 2), width: '10%', alignCell: 'right' },
                        { Header: '1° Vto.', accessor: 'fechaVencimiento1', Cell: (data) => getDateToString(data.value), width: '10%' },
                        { Header: '2° Vto.', accessor: 'fechaVencimiento2', Cell: (data) => getDateToString(data.value), width: '10%' },
                    ]}
                />
            )}

            {selectedVep && (
                <CuentaPagoDetalleModal
                    id={selectedVep.id}
                    onCancel={() => setSelectedVep(null)}
                />
            )}

        </section>
    </>
}

export default BusquedaVepsView
